const ENV = (!process.env.NODE_ENV || process.env.NODE_ENV) === 'development' ? 'DEV' : 'PROD';

const _DEV_HOST_ADDRESS = 'http://localhost:3001';
const _PROD_HOST_ADDRESS = 'https://art-generator-app.vercel.app';
const _KAKAO_REST_API_KEY = "506156205343417c8a22984b62147e4e";
const _KAKAO_JAVASCRIPT_KEY = "b9da0b18d443f518010f82113acbcc34";
const _API_SERVER_ADDRESS = "https://us-central1-art-generator-5a6dd.cloudfunctions.net/api";

// TOSS_CLIENT_KEY: "live_ck_jZ61JOxRQVEaqEdvmBaVW0X9bAqw", PROD KEY TOSS
// test_ck_OALnQvDd2VJw7p9eoOnrMj7X41mN

const CONFIG = {
  DEV: {
    HOST_URL: "http://localhost:3001",
    API_URL: _API_SERVER_ADDRESS,
    TOSS_CLIENT_KEY: "test_ck_OALnQvDd2VJw7p9eoOnrMj7X41mN",
    TOSS_PAYMENT_SUCCESS_CALLBACK_URL: `${_DEV_HOST_ADDRESS}/purchase/success`,
    TOSS_PAYMENT_FAIL_CALLBACK_URL: `${_DEV_HOST_ADDRESS}/purchase/fail`,
    TOSS_PAYMENT_KAKAO_DETECT_SUCCESS_CALLBACK_URL: `${_DEV_HOST_ADDRESS}/kakao/detect/purchase/success`,
    TOSS_PAYMENT_KAKAO_DETECT_FAIL_CALLBACK_URL: `${_DEV_HOST_ADDRESS}/kakao/detect/purchase/fail`,
    TOSS_PAYMENT_DIRECT_PURCHASE_SUCCESS_CALLBACK_URL: `${_DEV_HOST_ADDRESS}/purchase/direct/success`,
    TOSS_PAYMENT_DIRECT_PURCHASE_FAIL_CALLBACK_URL: `${_DEV_HOST_ADDRESS}/purchase/direct/fail`,
    KAKAO_REST_API_KEY: _KAKAO_REST_API_KEY,
    KAKAO_JAVASCRIPT_KEY: _KAKAO_JAVASCRIPT_KEY
  },
  PROD: {
    HOST_URL: "https://art-generator-app.vercel.app",
    API_URL: _API_SERVER_ADDRESS,
    TOSS_CLIENT_KEY: "live_ck_jZ61JOxRQVEaqEdvmBaVW0X9bAqw",
    TOSS_PAYMENT_SUCCESS_CALLBACK_URL: `${_PROD_HOST_ADDRESS}/purchase/success`,
    TOSS_PAYMENT_FAIL_CALLBACK_URL: `${_PROD_HOST_ADDRESS}/purchase/fail`,
    TOSS_PAYMENT_KAKAO_DETECT_SUCCESS_CALLBACK_URL: `${_PROD_HOST_ADDRESS}/kakao/detect/purchase/success`,
    TOSS_PAYMENT_KAKAO_DETECT_FAIL_CALLBACK_URL: `${_PROD_HOST_ADDRESS}/kakao/detect/purchase/fail`,
    TOSS_PAYMENT_DIRECT_PURCHASE_SUCCESS_CALLBACK_URL: `${_PROD_HOST_ADDRESS}/purchase/direct/success`,
    TOSS_PAYMENT_DIRECT_PURCHASE_FAIL_CALLBACK_URL: `${_PROD_HOST_ADDRESS}/purchase/direct/fail`,
    KAKAO_REST_API_KEY: _KAKAO_REST_API_KEY,
    KAKAO_JAVASCRIPT_KEY: _KAKAO_JAVASCRIPT_KEY
  }
}

export default {
  config: CONFIG[ENV],
}